const UPDATE_ITEMS = [
  { time: '2 小时前', title: '《庆余年 第二季》全集更新完毕，大结局高能名场面引爆全网讨论', tag: '热门' },
  { time: '5 小时前', title: '《长相思》第二季全集上线，相柳与小夭虐心结局看哭剧迷', tag: '新剧' },
  { time: '8 小时前', title: '《眼泪女王》韩剧全集高清字幕版已上线，中韩同步秒播', tag: '同步' },
  { time: '昨天', title: '《与凤行》全集免费观看人数突破百万，赵丽颖仙侠再封神', tag: '爆款' },
  { time: '昨天', title: '《墨雨云间》持续霸榜热搜，复仇爽剧掀起追剧狂潮', tag: '热搜' },
  { time: '2 天前', title: '《狐妖小红娘月红篇》全集开放，漫改还原度获原著粉盛赞', tag: '漫改' },
  { time: '3 天前', title: '久久影视站内国产剧全集资源突破 3000 部，覆盖主流热门剧集', tag: '公告' },
  { time: '4 天前', title: '高清播放引擎全面升级，全集在线观看画质提升至 1080P+', tag: '升级' },
];

const tagStyleMap: Record<string, string> = {
  '热门': 'bg-primary-100 text-primary-600',
  '新剧': 'bg-accent-100 text-accent-600',
  '同步': 'bg-secondary-100 text-secondary-600',
  '爆款': 'bg-primary-100 text-primary-600',
  '热搜': 'bg-accent-100 text-accent-600',
  '漫改': 'bg-secondary-100 text-secondary-600',
  '公告': 'bg-secondary-100 text-secondary-600',
  '升级': 'bg-accent-100 text-accent-600',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">追剧快讯</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            最新电视剧全集更新动态，追剧不落伍
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 border-l-2 border-primary-200 space-y-6">
            {UPDATE_ITEMS.map((item) => (
              <div key={item.title} className="relative">
                <div className="absolute -left-[29px] top-1.5 w-3 h-3 rounded-full bg-primary-500 ring-4 ring-background-50"></div>
                <div className="bg-background-50 rounded-lg p-4 border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-xs text-foreground-500">{item.time}</span>
                    <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${tagStyleMap[item.tag]}`}>{item.tag}</span>
                  </div>
                  <p className="text-sm text-foreground-800 leading-relaxed">{item.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}